import { render, staticRenderFns } from "./CreditPackagesTable.vue?vue&type=template&id=534d6058&"
import script from "./CreditPackagesTable.vue?vue&type=script&lang=js&"
export * from "./CreditPackagesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports